import { SelectType } from "@graphql";

export const aoeSectionInitialValues = {
  experience: {
    type: SelectType.ANY,
    value: []
  }
};
